export default __webpack_public_path__ + "static/mailSent-bb52c9e1f13af88bb4c76d03a2a15fc0.webp";